<template lang="pug">
  section
    header.header-settings
      .tabs
        .tab.primary-text.active
          span Account
    form-upload(@uploaded="uploaded")
      .form-field
        label
          h6 Avatar
          .form-field-image(:class="{ 'has-image': avatar }")
            .interact
              span
                font-awesome-icon.icon(:icon="['fad', 'user']")
            img(v-if="avatar", :src="avatar")

    div.form-field(v-if="avatar")
      button.button.button-alert(type="button", @click="removeAvatar") Remove Avatar

    form(@keyup.enter="submit", @submit.prevent="submit")

      AlertBox(v-if="error", type="danger", :text="error")

      div.form-field(:class="{error: $v.form.firstName.$error, 'error-required': !$v.form.firstName.required}")
        label
          h6 First Name
          input(type="text", minlength="2", maxlength="25", v-model="$v.form.firstName.$model")

      div.form-field(:class="{error: $v.form.lastName.$error, 'error-required': !$v.form.lastName.required}")
        label
          h6 Last Name
          input(type="text", minlength="2", maxlength="25", v-model="$v.form.lastName.$model")

      div(v-if="company.isMember")
        div.form-field(:class="{error: $v.form.email.$error, 'error-required': !$v.form.email.required}")
          label
            h6 Email Address
            input(type="text", v-model="$v.form.email.$model")


        .form-field-group
          h6 Notifications
          .form-field(v-for="(value, key) in form.notifications", v-if="notificationsMapper[key]")
            .form-field-toggle
              label.toggle-switch
                .row.center
                  .col
                    input(type="checkbox", v-model="form.notifications[key]")
                    .toggle-switch-slider
                      .toggle-switch-knob
                  .col
                    div
                      span {{notificationsMapper[key].label}}

      div.form-field
        SubmitButton(label="Save", :formState="formState")
</template>

<script>

import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import FormUpload from '@/components/form/FormUpload'
import { form } from '@/mixins/form'

const notificationsMapper = {
  feature_assigned: {
    label: 'Assignment of a feature'
  },
  feature_commented: {
    label: 'Comment on a feature you created'
  },
  feature_status_changed: {
    label: 'Status change on a feature you are following'
  },
  feature_linked: {
    label: 'Feature you follow is merged into another'
  }
}

export default {
  name: 'SettingsAccount',
  mixins: [form],
  components: {
    FormUpload
  },
  beforeCreate () {
    this.$store.dispatch('user/getUser')
      .then(() => {
        this.form = Object.assign({}, this.$store.state.user)
        console.log(this.form)
      })

  },
  mounted () {
    //console.log('[mounted]', this.user)
    //this.form = this.user
  },
  data () {
    return {
      notificationsMapper,
      formState: 'initial',
      form: {
        firstName: '',
        lastName: '',
        email: '',
        notifications: {}
      },
      error: null
    }
  },
  validations: {
    form: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      email: {
        required
      }
    }
  },
  computed: {
    ...mapState({
      company: state => state.company
    }),
    avatar () {
      let avatar = this.form.avatarUrl ? `${this.form.avatarUrl}?fit=crop&w=128&h=128&crop=faces` : null
      return avatar
    }
  },
  methods: {
    removeAvatar () {
      this.$set(this.form, 'avatarUrl', null)
    },
    uploaded(attachment) {
      this.$set(this.form, 'avatarUrl', attachment.url)
    },
    submit () {
      if (this.__formInvalid()) return

      this.formState = 'pending'
      console.log(this.form)
      this.$store.dispatch('user/updateUser', this.form)
        .then(() => {
          this.formState = 'success'
          this.$v.$reset()
        }, error => {
          this.error = error
          this.formState = 'initial'

        })
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>
